import type { Length } from '@gitbook/api-client';

/**
 * Parse a string or number to a Length
 */
export function parseLength(value: string | number): Length | undefined {
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        const match = value.match(/^(\d+(?:\.\d+)?)(px|%)$/);
        if (match) {
            return { value: Number(match[1]), unit: match[2] }; // Return object with value and unit
        }
        const numberValue = Number.parseInt(value, 10); // Invalid format
        if (!Number.isNaN(numberValue)) {
            return numberValue; // Return as pixel value if it's a valid number
        }
    }
}
